import { render, staticRenderFns } from "./BudzReport.vue?vue&type=template&id=2fcf465b&scoped=true&"
import script from "./BudzReport.vue?vue&type=script&lang=js&"
export * from "./BudzReport.vue?vue&type=script&lang=js&"
import style0 from "./BudzReport.vue?vue&type=style&index=0&id=2fcf465b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcf465b",
  null
  
)

export default component.exports